var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as FragmentV2 } from 'vue-frag';
import { isVue2, defineComponent } from 'vue-demi';
export var Fragment = '#fragment';
var FragmentComponent;
if (isVue2) {
    FragmentComponent = __assign({ name: 'Fragment' }, FragmentV2);
}
else {
    /* istanbul ignore next */
    FragmentComponent = defineComponent({
        name: 'Fragment',
        render: function () {
            var _a, _b;
            return (_b = (_a = this.$slots).default) === null || _b === void 0 ? void 0 : _b.call(_a);
        },
    });
}
export { FragmentComponent };
//# sourceMappingURL=fragment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/shared/fragment.js
// module id = null
// module chunks = 